// Mock data for Marina Homes serviced apartment website

export const heroImage = "https://images.unsplash.com/photo-1737737210863-387afd35344e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjb3p5JTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzY5MDY2ODc5fDA&ixlib=rb-4.1.0&q=85";

export const businessInfo = {
  name: "Marina Homes",
  phone: "0753388226",
  email: "marinahomestz@gmail.com",
  googleMapsReviewUrl: "https://www.google.com/maps/place/Marina+Homes/@-6.7771937,39.2441512,17z/data=!4m8!3m7!1s0x185c4de2205367b1:0xcc7de941cf2ff53d!8m2!3d-6.7771937!4d39.2467315!9m1!1b1!16s%2Fg%2F11ypzycndt?authuser=0&entry=ttu&g_ep=EgoyMDI2MDExOS4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D",
  airbnbReviewUrl: "https://www.airbnb.com/users/profile/1468463989683297636"
};

export const apartments = [
  {
    id: 1,
    name: "Apartment 1",
    type: "Studio Deluxe",
    images: [
      {
        url: "https://images.unsplash.com/photo-1638454668466-e8dbd5462f20",
        alt: "Modern bedroom with natural lighting"
      },
      {
        url: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92",
        alt: "Living area with plants"
      },
      {
        url: "https://images.unsplash.com/photo-1484154218962-a197022b5858",
        alt: "Modern kitchen with island"
      }
    ]
  },
  {
    id: 2,
    name: "Apartment 2",
    type: "One Bedroom Classic",
    images: [
      {
        url: "https://images.unsplash.com/photo-1615874959474-d609969a20ed",
        alt: "Cozy bedroom with warm tones"
      },
      {
        url: "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31",
        alt: "Bright living space"
      },
      {
        url: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a",
        alt: "Modern bathroom with dual sinks"
      }
    ]
  },
  {
    id: 3,
    name: "Apartment 3",
    type: "Two Bedroom Premium",
    images: [
      {
        url: "https://images.unsplash.com/photo-1556020685-ae41abfc9365",
        alt: "Stylish bedroom with wooden furniture"
      },
      {
        url: "https://images.unsplash.com/photo-1726090401458-7abb00f7450c",
        alt: "Living room with fireplace"
      },
      {
        url: "https://images.unsplash.com/photo-1610527003928-47afd5f470c6",
        alt: "Contemporary white kitchen"
      }
    ]
  },
  {
    id: 4,
    name: "Apartment 4",
    type: "Executive Suite",
    images: [
      {
        url: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
        alt: "Luxury bedroom with dark tones"
      },
      {
        url: "https://images.pexels.com/photos/34591842/pexels-photo-34591842.jpeg",
        alt: "Warm living room"
      },
      {
        url: "https://images.unsplash.com/photo-1597320775230-8b0d40daa792",
        alt: "Dining area with wooden table"
      }
    ]
  },
  {
    id: 5,
    name: "Apartment 5",
    type: "Studio Modern",
    images: [
      {
        url: "https://images.pexels.com/photos/6782578/pexels-photo-6782578.jpeg",
        alt: "Cozy bedroom with warm lighting"
      },
      {
        url: "https://images.pexels.com/photos/35348456/pexels-photo-35348456.jpeg",
        alt: "Living space with character"
      },
      {
        url: "https://images.unsplash.com/photo-1630699293784-9f977570255a",
        alt: "Modern kitchen setup"
      }
    ]
  },
  {
    id: 6,
    name: "Apartment 6",
    type: "One Bedroom Comfort",
    images: [
      {
        url: "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf",
        alt: "Minimalist bedroom"
      },
      {
        url: "https://images.unsplash.com/photo-1629042306551-641c2715737b",
        alt: "Modern dining area"
      },
      {
        url: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5",
        alt: "Contemporary bathroom"
      }
    ]
  },
  {
    id: 7,
    name: "Apartment 7",
    type: "Penthouse Luxury",
    images: [
      {
        url: "https://images.unsplash.com/photo-1540518614846-7eded433c457",
        alt: "Stylish bedroom with colors"
      },
      {
        url: "https://images.unsplash.com/photo-1689043528099-2ba014dd7c64",
        alt: "Kitchen-dining combo"
      },
      {
        url: "https://images.unsplash.com/photo-1620626011761-996317b8d101",
        alt: "Spa-like bathroom"
      }
    ]
  },
  {
    id: 8,
    name: "Apartment 8",
    type: "Family Suite",
    images: [
      {
        url: "https://images.pexels.com/photos/3144580/pexels-photo-3144580.jpeg",
        alt: "Modern bedroom with wood tones"
      },
      {
        url: "https://images.pexels.com/photos/7546561/pexels-photo-7546561.jpeg",
        alt: "Contemporary kitchen"
      },
      {
        url: "https://images.pexels.com/photos/14002093/pexels-photo-14002093.jpeg",
        alt: "Elegant dining setup"
      }
    ]
  },
  {
    id: 9,
    name: "Apartment 9",
    type: "Studio Elite",
    images: [
      {
        url: "https://images.pexels.com/photos/439227/pexels-photo-439227.jpeg",
        alt: "Contemporary bedroom design"
      },
      {
        url: "https://images.pexels.com/photos/94865/pexels-photo-94865.jpeg",
        alt: "Traditional style kitchen"
      },
      {
        url: "https://images.pexels.com/photos/32277993/pexels-photo-32277993.jpeg",
        alt: "Modern bathroom"
      }
    ]
  },
  {
    id: 10,
    name: "Apartment 10",
    type: "Two Bedroom Executive",
    images: [
      {
        url: "https://images.unsplash.com/photo-1638454668466-e8dbd5462f20",
        alt: "Spacious bedroom"
      },
      {
        url: "https://images.pexels.com/photos/18470962/pexels-photo-18470962.jpeg",
        alt: "Dining area with modern furniture"
      }
    ]
  },
  {
    id: 11,
    name: "Apartment 11",
    type: "Garden View Suite",
    images: [
      {
        url: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
        alt: "Elegant bedroom"
      },
      {
        url: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92",
        alt: "Living room with natural light"
      }
    ]
  },
  {
    id: 12,
    name: "Apartment 12",
    type: "City View Premium",
    images: [
      {
        url: "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf",
        alt: "Modern bedroom"
      },
      {
        url: "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31",
        alt: "Airy living space"
      }
    ]
  },
  {
    id: 13,
    name: "Apartment 13",
    type: "Cozy Corner Studio",
    images: [
      {
        url: "https://images.unsplash.com/photo-1615874959474-d609969a20ed",
        alt: "Warm bedroom retreat"
      },
      {
        url: "https://images.unsplash.com/photo-1726090401458-7abb00f7450c",
        alt: "Inviting living area"
      }
    ]
  }
];

export const customerReviews = [
  {
    id: 1,
    name: "Amina K.",
    rating: 5,
    comment: "Marina Homes exceeded my expectations! The apartment was spotlessly clean, well-maintained, and had everything we needed for our 2-week stay. The location is perfect - close to the beach and restaurants. Highly recommend for anyone visiting Dar es Salaam!",
    date: "January 2025",
    avatar: "AK",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/74.jpg",
    platform: "Google"
  },
  {
    id: 2,
    name: "Kwame A.",
    rating: 5,
    comment: "Excellent serviced apartment! Very spacious, modern, and comfortable. The host was incredibly responsive and helpful with local recommendations. The apartment had fast WiFi which was perfect for remote work. Will definitely stay here again on my next trip to Tanzania.",
    date: "December 2024",
    avatar: "KA",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/male/71.jpg",
    platform: "Google"
  },
  {
    id: 3,
    name: "Aisha M.",
    rating: 5,
    comment: "We had a wonderful experience at Marina Homes. The apartment felt like a home away from home - fully equipped kitchen, comfortable beds, and a beautiful balcony. The neighborhood is safe and quiet. Perfect for families or long stays!",
    date: "November 2024",
    avatar: "AM",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/67.jpg",
    platform: "Airbnb"
  },
  {
    id: 4,
    name: "Chen Wei",
    rating: 5,
    comment: "Outstanding service and beautiful apartment! Marina Homes is perfectly located near the beach and shopping areas. The apartment was exactly as described - clean, spacious, and well-furnished. Communication with the host was excellent. Highly recommended!",
    date: "November 2024",
    avatar: "CW",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/male/46.jpg",
    platform: "Google"
  },
  {
    id: 5,
    name: "Fatima H.",
    rating: 5,
    comment: "Best serviced apartment in Dar! Very clean, secure building, and the apartment has all modern amenities. I was traveling for business and this was the perfect base. The host made check-in very easy and was available whenever I had questions. Five stars!",
    date: "October 2024",
    avatar: "FH",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/78.jpg",
    platform: "Google"
  },
  {
    id: 6,
    name: "Joseph N.",
    rating: 5,
    comment: "Stayed at Marina Homes for a month and loved every moment. The apartment is well-designed, comfortable, and has great natural light. Location is excellent with easy access to everything you need. The host is professional and very accommodating. Highly recommend!",
    date: "October 2024",
    avatar: "JN",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/male/69.jpg",
    platform: "Google"
  },
  {
    id: 7,
    name: "Zainab A.",
    rating: 5,
    comment: "Marina Homes provided the perfect accommodation for our family vacation. The apartment was spacious enough for all of us, very clean, and the kitchen was fully equipped. Great value for money and the host was wonderful to work with!",
    date: "September 2024",
    avatar: "ZA",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/70.jpg",
    platform: "Airbnb"
  },
  {
    id: 8,
    name: "Yuki T.",
    rating: 5,
    comment: "Exceptional apartment! Everything was perfect from check-in to check-out. The apartment is modern, clean, and in a great location. Marina Homes offers the best of both worlds - hotel comfort with the convenience of your own space. Will definitely be back!",
    date: "September 2024",
    avatar: "YT",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/32.jpg",
    platform: "Google"
  },
  {
    id: 9,
    name: "Emmanuel K.",
    rating: 5,
    comment: "I've stayed in many serviced apartments, and Marina Homes is among the best. Attention to detail, cleanliness, and comfort are top-notch. The apartment feels luxurious yet homey. Perfect location and the host is incredibly responsive. Strongly recommend!",
    date: "August 2024",
    avatar: "EK",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/male/74.jpg",
    platform: "Google"
  },
  {
    id: 10,
    name: "Thandiwe S.",
    rating: 5,
    comment: "Great experience at Marina Homes! The apartment was exactly what we needed - comfortable, well-located, and affordable. Everything worked perfectly and the host provided excellent service. This is now our go-to place whenever we visit Dar es Salaam!",
    date: "August 2024",
    avatar: "TS",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/65.jpg",
    platform: "Google"
  },
  {
    id: 11,
    name: "Priya R.",
    rating: 5,
    comment: "Marina Homes offers excellent value. The apartment is spacious, bright, and very comfortable. I appreciated the fast WiFi, modern appliances, and the secure parking. The host was professional and made everything easy. Perfect for business travelers!",
    date: "July 2024",
    avatar: "PR",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/female/41.jpg",
    platform: "Airbnb"
  },
  {
    id: 12,
    name: "Kofi O.",
    rating: 5,
    comment: "Absolutely loved staying at Marina Homes! The apartment is beautiful, well-maintained, and in a fantastic location. Everything you need is within walking distance. The host went above and beyond to ensure we had a comfortable stay. Highly recommend to anyone!",
    date: "July 2024",
    avatar: "KO",
    avatarImage: "https://xsgames.co/randomusers/assets/avatars/male/78.jpg",
    platform: "Google"
  }
];
